import Vue from "vue";
import Vuex from "vuex";

import Account from "./modules/account";
import Alert from "./modules/alert";
import Bank from "./modules/bank";
import Breadcrumb from "./modules/breadcrumb";
import Comment from "./modules/comment";
import Contact from "./modules/contact";
import DashBoard from "./modules/dashBoard";
import Department from "./modules/department";
import Employee from "./modules/employee";
import Export from "./modules/export";
import ImportEmployee from "./modules/importEmployee";
import Loading from "./modules/loading";
import LogIn from "./modules/logIn";
import Position from "./modules/position";
import RevenueDeduct from "./modules/revenueDeduct";
import Salary from "./modules/salary";
import Setting from "./modules/setting";
import Statement from "./modules/statement";
import Videofeedback from "./modules/videoFeedback";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    LogIn,
    Breadcrumb,
    Department,
    Account,
    Alert,
    Loading,
    RevenueDeduct,
    Position,
    Salary,
    Employee,
    Bank,
    Statement,
    Setting,
    Contact,
    ImportEmployee,
    Export,
    DashBoard,
    Comment,
    Videofeedback,
  },
  strict: true,
});

export default store;
